import React from 'react';
import styled from '@benzinga/themetron';
import { Switch } from 'antd';

interface PreferencesToggleProps {
  active: boolean;
  label: string | React.ReactElement;
  onClick(checked: boolean): void;
}

export const PreferencesToggle: React.FC<PreferencesToggleProps> = props => (
  <PreferencesToggleDiv>
    <Switch checked={props.active} onChange={props.onClick} />
    <label>{props.label}</label>
  </PreferencesToggleDiv>
);

const PreferencesToggleDiv = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 1em;
  > label {
    font-size: 1.1em;
    margin-left: 1em;
  }
`;
